export const PARTNER_XING = 'xing';

export const PARTNER_DATA = {
    [PARTNER_XING]: {
        planType: 'ft_partnership_xing',
        name: 'XING',
        avatar: `${process.env.staticRoot}/img/design/referral/partners/xing-avatar.jpg`
    }
};
